import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sends a GA4 page_view on every route change, including the first render.
 * The gtag config in public/index.html sets send_page_view: false so this is the only source
 * of page views; that keeps counts correct whether or not the GA4 stream's "page changes based
 * on browser history events" option is on. Plausible tracks history changes on its own.
 */
const PageViewTracker = () => {
  const { pathname, search } = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = pathname + search;
    if (lastPath.current === path) return undefined;
    lastPath.current = path;
    // Helmet updates document.title a frame after render; wait briefly so the title is right.
    const timer = setTimeout(() => {
      if (typeof window.gtag !== "function") return;
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: path,
        page_title: document.title,
      });
    }, 250);
    return () => clearTimeout(timer);
  }, [pathname, search]);

  return null;
};

export default PageViewTracker;
